import { CategoryNameEnum, PhasesProtocols } from "pages/Pipefy/enum";
import { CurrentPhaseMovedToPhasesProps, PhasesHistoryProps } from "pages/Pipefy/interface";

export const ruleHidePhaseCancel = (phases: CurrentPhaseMovedToPhasesProps[], currentPhase: string, categoryProtocol: string, card: any) => {
    const validPhasesToCancel = [PhasesProtocols.REANALISE_LOGISTICA_REVERSA, PhasesProtocols.DIVERGENCIA_DA_DEVOLUCAO];

    if (validPhasesToCancel.some(phase => phase === currentPhase))
        return phases;

    if (categoryProtocol !== CategoryNameEnum.RECLAMACAO_TECNICA && currentPhase !== PhasesProtocols.AVALIACAO_LOGISTICA_REVERSA)
        return phases.filter(phase => phase.name.toUpperCase() !== PhasesProtocols.PROTOCOLO_CANCELADO.toUpperCase());

    if (categoryProtocol === CategoryNameEnum.RECLAMACAO_TECNICA && card != undefined
        && card.phases_history.some((history: PhasesHistoryProps) => history.phase?.name === PhasesProtocols.AVALIACAO_QUALIDADE))
          return phases.filter(phase => phase.name.toUpperCase() !== PhasesProtocols.PROTOCOLO_CANCELADO.toUpperCase());

    return phases;
};